import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MeetingBooksLinkApiService } from '../../services/meeting-books-link-api.service';
import {
  MeetingBookingAvailabilityRequest,
  MeetingBookingAvailabilityResponse,
} from '../../models/meeting.model';
import { ConfirmDialogService } from '../../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../../shared/services/toast.service';

const DAYS = [
  { value: 0, label: 'Domingo' },
  { value: 1, label: 'Lunes' },
  { value: 2, label: 'Martes' },
  { value: 3, label: 'Miércoles' },
  { value: 4, label: 'Jueves' },
  { value: 5, label: 'Viernes' },
  { value: 6, label: 'Sábado' },
];

@Component({
  selector: 'app-booking-availability',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './booking-availability.component.html',
})
export class BookingAvailabilityComponent implements OnChanges {
  @Input() bookingLinkId!: number;

  readonly days = DAYS;
  items: MeetingBookingAvailabilityResponse[] = [];
  loading = false;
  saving = false;

  // Nuevo slot
  newDay = 1;
  newStart = '09:00';
  newEnd = '17:00';

  constructor(
    private api: MeetingBooksLinkApiService,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) {}

  ngOnChanges(c: SimpleChanges): void {
    if (c['bookingLinkId'] && this.bookingLinkId) this.load();
  }

  dayLabel(day: number): string {
    return this.days.find((d) => d.value === day)?.label || '—';
  }

  timeString(v: any): string {
    if (!v) return '';
    if (typeof v === 'string') return v.slice(0, 5);
    const h = String(v.hour ?? 0).padStart(2, '0');
    const m = String(v.minute ?? 0).padStart(2, '0');
    return `${h}:${m}`;
  }

  load(): void {
    this.loading = true;
    this.api.listAvailability(this.bookingLinkId).subscribe({
      next: (data) => {
        this.items = [...data].sort(
          (a, b) =>
            a.dayOfWeek - b.dayOfWeek ||
            this.timeString(a.startTime).localeCompare(this.timeString(b.startTime))
        );
        this.loading = false;
      },
      error: () => (this.loading = false),
    });
  }

  add(): void {
    if (!this.newStart || !this.newEnd) return;
    this.saving = true;
    const body: MeetingBookingAvailabilityRequest = {
      dayOfWeek: this.newDay,
      startTime: `${this.newStart}:00`,
      endTime: `${this.newEnd}:00`,
      isActive: true,
    };
    this.api.createAvailability(this.bookingLinkId, body).subscribe({
      next: () => {
        this.saving = false;
        this.load();
        this.toast.created('Horario');
      },
      error: (err) => {
        this.saving = false;
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al crear horario' });
      },
    });
  }

  toggle(item: MeetingBookingAvailabilityResponse): void {
    this.api
      .updateAvailability(this.bookingLinkId, item.id, {
        dayOfWeek: item.dayOfWeek,
        startTime: item.startTime,
        endTime: item.endTime,
        isActive: !item.isActive,
      })
      .subscribe({ next: () => this.load() });
  }

  async remove(item: MeetingBookingAvailabilityResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar horario',
      message: '¿Eliminar este horario?'
    });
    if (!ok) return;
    this.api.deleteAvailability(this.bookingLinkId, item.id).subscribe({
      next: () => { this.load(); this.toast.deleted('Horario'); },
    });
  }
}
